/**
 *
 * @module entry
 * @desc {SDK.Identity.Bam} entry point.
 *
 */

import BamIdentityApi from './bamIdentityApi';
import BamIdentityManager from './bamIdentityManager';

/**
 *
 * @typedef SDK.Identity.Bam
 * @type {Object}
 *
 * @property {BamIdentityApi} BamIdentityApi
 * @property {BamIdentityManager} BamIdentityManager
 *
 */

/**
 *
 * @type {SDK.Identity.Bam}
 *
 */
export default {

    BamIdentityApi,
    BamIdentityManager

};



// WEBPACK FOOTER //
// ./src/identity/bam/entry.js